/**
 *  Behavior error
 *
 *  @class BehaviorError
 *  @extends Error
 */
class BehaviorError extends Error {
  constructor(debugMessage) {
    var _options$errorCode;
    let statusCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    let errorData = arguments.length > 2 ? arguments[2] : undefined;
    let cause = arguments.length > 3 ? arguments[3] : undefined;
    let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    super(debugMessage, cause ? {
      cause
    } : undefined);
    if (errorData) {
      this.prodData = errorData;
    }
    Error.captureStackTrace(this, this.constructor);
    this.name = 'BehaviorError';
    this.statusCode = statusCode;
    this.debugMessage = debugMessage;
    this.messageKey = 'nativebehavior_error';
    this.logLevel = 'error';

    // `errorCode` is the curated, client-facing code; `code` is kept as a
    // backward-compatible alias.
    this.errorCode = (_options$errorCode = options.errorCode) !== null && _options$errorCode !== void 0 ? _options$errorCode : options.code;
    this.detailKey = options.detailKey;
    this.hintKey = options.hintKey;
    this.detail = options.detail;
    this.hint = options.hint;
    if (cause !== null && cause !== void 0 && cause.stack) {
      this.stack = "".concat(this.stack, "\n\nCaused by:\n").concat(cause.stack);
    }
  }
}
module.exports = BehaviorError;